import { useContext, useEffect } from "react";

import CustomConnectBtn from "../components/DConnectBtn/CustomConnectBtn";
import FixedInputs from "../components/FixedInputs";
import MessageEntityAlert from "../components/MessageEntityAlert";
import UpdateError from "../components/Update/UpdateError";
import UpdateLoading from "../components/Update/UpdateLoading";
import UpdateSuccess from "../components/Update/UpdateSuccess";
import UpdateUserConfirmation from "../components/Update/UpdateUserConfirmation";
import ConfirmationTimer from "../ConfirmationTimer";
import Context from "../context";
import { useDynamicForm } from "../hooks/useDynamicForm";
import FormWrapper from "./UpdateFormWrapper";

// ----------------------------------------------------------------------

export const DynamicFormWrapper = () => {
	const { params, selectedValue, entity } = useContext(Context);

	const {
		methods,
		onSubmit,
		isSuccess,
		isError,
		isLoading,
		totpNeeded,
		userConfirmationNeeded,
		errorMessage
	} = useDynamicForm({
		fields: params,
		fieldSelected: selectedValue
	});

	useEffect(() => {
		if (totpNeeded || userConfirmationNeeded) methods.reset();
	}, [totpNeeded, userConfirmationNeeded]);

	useEffect(() => {
		if (isError) methods.reset();
	}, [isError]);

	return (
		<FormWrapper methods={methods} onSubmit={onSubmit}>
			{isLoading && !entity?.maintenance && <UpdateLoading />}
			{isSuccess && !entity?.maintenance && <UpdateSuccess />}
			<MessageEntityAlert />
			{isError && !userConfirmationNeeded && !entity?.maintenance && <UpdateError />}
			{!isLoading && totpNeeded && !isSuccess && (
				<FixedInputs
					userConfirmationNeeded={userConfirmationNeeded}
					totpNeeded={totpNeeded}
					control={methods.control}
				/>
			)}
			{!isLoading && (userConfirmationNeeded || totpNeeded) && (
				<ConfirmationTimer isTotp={totpNeeded} />
			)}

			{userConfirmationNeeded && !isSuccess && (
				<UpdateUserConfirmation errorMessage={errorMessage} isLoading={isLoading} />
			)}
			{totpNeeded && !isSuccess && <CustomConnectBtn loading={isLoading} />}
		</FormWrapper>
	);
};

export default DynamicFormWrapper;
